import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";
import Contract from "slotworks/utils/contracts/contract";
import Parallel from "slotworks/utils/contracts/parallel";

export enum DimType {
    Highlight,
    Win,
    Cycle
}

export default function DimSymbolsCommand(symbols: SymbolComponent[], type: DimType, result?: SymbolWinResult): Contract<void> {
    const dimSymbolMethods: Array<() => Contract<void>> = [];

    for (const symbol of symbols) {
        dimSymbolMethods.push(getDimAction(symbol, type, result));
    }

    return new Parallel(dimSymbolMethods);
}

function getDimAction(symbol: SymbolComponent, type: DimType, result?: SymbolWinResult) {
    switch (type) {
        case DimType.Highlight:
            return () => symbol.highlightDim(result);
        case DimType.Win:
            return () => symbol.winDim(result);
        case DimType.Cycle:
            return () => symbol.cycleDim(result);
        default:
            throw new Error(`Invalid symbol dim type requested: "${DimType}"`);
    }
}
